<template>
  <th data-int="cart-header-book">
    {{ $t('itemName', { item: $tc('book', 1)}) }}
  </th>
</template>

<script>
export default {
  name: 'CartHeaderUom'
};
</script>

<style scoped>

</style>
